<template>
  <span aria-label="Campo obligatorio" class="!text-red-500"> * </span>
</template>

<script>
export default {
  name: 'obligatory-icon',
}
</script>
